// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

// --- HS Code
import { ReportsBaseService } from './reports-base.service';
import { ReportListItem, ReportRequestModel, SavedReportTypes } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class ReportsMockService extends ReportsBaseService {
  constructor(modalService: NgbModal) {
    super(modalService);
  }

  loadReports(): void {
    const reports = new Array<ReportListItem>();
    reports.push({
      surveyName: 'My First Survey',
      lastUpdated: new Date(2018, 3, 5),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    reports.push({
      surveyName: 'My Second Survey',
      lastUpdated: new Date(2019, 2, 13),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    reports.push({
      surveyName: 'My Third Survey',
      lastUpdated: new Date(2019, 6, 21),
      viewLink: '#',
      downloadLink: '#'
    } as ReportListItem);

    this._reportsList$.next(reports.map(r => {
      r.busy = false;
      return r;
    }));
  }

  getReportOnline(identifier: string): void {
    this._toggleReportLoading(identifier, true);
  }

  getReportPdf(identifier: string, reportType: SavedReportTypes): void {
    this._toggleReportLoading(identifier, true);
  }

  regenerateReportPdf(identifier: string): void {
    this._toggleReportLoading(identifier, true);
  }

  submitReportRequest(model: ReportRequestModel): void {
  }

  getJournalReportPdf(): void { }
}
